<template>
	<el-dialog class="phoneDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				发票申请
			</div>
		</div>
		<div class="dislogConent">
			<div class="menu">
				<div class="menuItem" :class="selIndex == 1 ? 'menuItemSel' : 'menuItemNor'" @click="selIndex = 1">个人
				</div>
				<div class="menuItem" :class="selIndex == 2 ? 'menuItemSel' : 'menuItemNor'" @click="selIndex = 2">企业
				</div>
			</div>
			<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="开票金额：" prop="cost">
					<div class="form-group" style="width: 3.85rem;">
						<div style="font-weight: 700;font-size: .2rem;color: rgba(255, 255, 255, 1);"><span
								style="font-weight: 400;">￥</span>{{orderData.order_price ? orderData.order_price : '0'}}
						</div>
					</div>
				</el-form-item>
				<el-form-item label="企业名称：" prop="qy_name" v-if="selIndex == 2">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="ruleForm.qy_name" placeholder="请输入企业名称" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="公司税号：" prop="qy_num" v-if="selIndex == 2">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="ruleForm.qy_num" placeholder="请输入公司税号" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="联系人：" prop="lxr">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="ruleForm.lxr" placeholder="请输入联系人" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="联系方式：" prop="phone">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="ruleForm.phone" placeholder="请输入联系方式" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="邮箱：" prop="email">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="ruleForm.email" placeholder="请输入邮箱" class="form-input" />
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium"
					@click="submitPhoneForm('phoneRuleForm')">确认申请</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ApplyInvoiceDialog',
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			orderData: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				selIndex: 1,
				ruleForm: {
					qy_name: '',
					qy_num: '',
					lxr: '',
					email: '',
					phone: '',
				},
				rules: {
					qy_name: [{
						required: true,
						message: '请输入公司税号企业名称',
						trigger: 'blur'
					}],
					qy_num: [{
						required: true,
						message: '请输入公司税号',
						trigger: 'blur'
					}],
					lxr: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			handleClose() {
				this.ruleForm = {
					qy_name: '',
					qy_num: '',
					lxr: '',
					email: '',
					phone: '',
				}
				this.$emit('close')
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {}
						if (this.selIndex == 1) {
							params = {
								id: this.orderData.id,
								lx_type: this.selIndex,
								lxr: this.ruleForm.lxr,
								email: this.ruleForm.email,
								phone: this.ruleForm.phone,
							}
						} else {
							params = {
								id: this.orderData.id,
								qy_name: this.ruleForm.qy_name,
								qy_num: this.ruleForm.qy_num,
								lx_type: this.selIndex,
								lxr: this.ruleForm.lxr,
								email: this.ruleForm.email,
								phone: this.ruleForm.phone,
							}
						}
						this.$api.post('/UserD/invoice_add', params).then(res => {
							if (res.code == 1) {
								this.$emit('update')
							} else {
								this.$message.error(res.msg)
							}
							this.handleClose()
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.phoneDialog {
		::v-deep .el-dialog {
			width: 5.4rem;
			border-radius: .12rem;
			background: rgba(31, 32, 39, 1);
			box-shadow: 0px 2px 23px 0px rgba(16, 97, 198, 0.2);
			border: .01rme solid rgba(151, 151, 151, 0.2);

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: rgba(255, 255, 255, .9);
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}


			&__body {
				padding: 0 .24rem;

				.menu {
					margin: 0 auto .24rem;
					width: 2.6rem;
					display: flex;
					align-items: center;
					border-radius: .08rem;
					border: .01rem solid rgba(255, 255, 255, .3);
					overflow: hidden;

					.menuItem {
						width: 1.3rem;
						height: .42rem;
						font-weight: 500;
						font-size: .14rem;
						color: rgba(255, 255, 255, .8);
						line-height: .42rem;
						text-align: center;
						cursor: pointer;
					}

					.menuItemNor {
						background: rgba(31, 32, 39, 1);
					}

					.menuItemSel {
						background: rgba(22, 115, 230, 1);
					}
				}

				.form-group {
					// margin-top: .16rem;
				}

				.form-input {
					width: 100%;
					height: 0.44rem;
					border: none;
					border-radius: 0.04rem;
					background: rgba(255, 255, 255, .08);
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #FFFFFF;
					outline: none;
					transition: border-color 0.3s ease;

					// &:focus {
					// 	border-color: #E29358;
					// }

					&::placeholder {
						color: rgba(255, 255, 255, .4);
					}
				}

				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: .9rem;
							padding: 0 .12rem 0 0;
							font-size: .14rem;
							color: rgba(255, 255, 255, .8);
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {
							line-height: .52rem;
							font-size: .14rem;

							.el-input {
								line-height: .52rem;

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.76rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #FFFFFF;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>